export type SkillPanelEditorOverrides = {
    forceTextarea?: boolean;
    forceRichEditor?: boolean;
};

/**
 * Decides whether the markdown editor should render as a plain textarea (mobile-friendly)
 * instead of the rich SimpleMDE editor.
 *
 * By default, narrow viewports get the textarea. Optional overrides provide a seam for
 * future callers (feature flags, user preferences) without coupling the view to the
 * decision logic. When both overrides are set, forceRichEditor wins — it is the more
 * explicit power-user opt-in and should override a broader forceTextarea preference.
 */
export function shouldUseTextareaEditor(
    isNarrow: boolean,
    overrides?: SkillPanelEditorOverrides,
): boolean {
    if (overrides?.forceRichEditor) return false;
    if (overrides?.forceTextarea) return true;
    return isNarrow;
}
